module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACwAAAAsCAYAAAAehFoBAAAAAXNSR0IArs4c6QAAAQNJREFUWEftlsEJAjEQRf/vQW82YQceLMGDHuzCizV4sAlBwQY82INN6El7GFnIgsiuBDIRB3/OyfDyMkk+EWwwGC8EXPvEXA2b2QjAFsAkgZ8BrEjevDbiBpxgLwAGb3APAGOSVw9oT+AjgFkP1IHk4teA7x12W8YHyaGASwyY2R7AvKfGjuSypH671rOHmxcizqVrDKSXYgNgmoycAKy9Xoimppthj+POqSHgHEslc2S4xF7O2v82rLTW0SNuLWFmSmtdl9DTcLh4qbRWtSWU1nq+PbdLl/OteswRsIfFTzVkOJRhpTWltRcDZhYu/IQDVlpTWqv9SVQ3/I0NKEvUtvwEnjGELfO7SaMAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/report/weekly/history.png
// module id = 8sMi
// module chunks = 0